module.exports = __webpack_public_path__ + "static/media/mia-malkova-win.6ce3c743.jpg";